import moment from "moment";

export default function DiamondMapper(user, checkedIn) {
    if (!user)
        return {};

    const profile = user.profile || {};
    const profileB = user.profileB && user.profileB
        ? {
            ...user.profileB,
            birthday: null,
            birthdate: user.profileB.birthday ? moment.utc(user.profileB.birthday).format("MMMM DD, YYYY") : "",
            anniversary: user.profileB.anniversary ? moment.utc(user.profileB.anniversary).format("MMMM DD, YYYY") : "",
        } : null;

    const eventInfo = user.eventInfo || {};
    const businessInfo = user.businessInfo || {};
    const gracePeriod = businessInfo.gracePeriod || {};
    const qualify = businessInfo && businessInfo.qualifyingRequirementsByYear && businessInfo.qualifyingRequirementsByYear.length > 0
        ? businessInfo.qualifyingRequirementsByYear[0]
        : {};

    return {
        userId: user._id,
        iboNum: user.iboNumber || "N/A",
        accessLevel: getAccessLevel(user.accessLevel),

        iboB: profileB,
        committeesB: profileB && profileB.committees || [],
        committees: profile.committees,
        
        canSwap: profileB && profileB.firstName ? true : false,

        
        firstName: profile.firstName || "",
        lastName: profile.lastName || "",

        photo: profile.photoUrl || "N/A",
        email: profile.email || "N/A",
        phoneNumber: profile.phone || "N/A",
        address: profile.address || "N/A",
        spouse: profile.spouse || "",

        birthdate: profile.birthday ? moment.utc(profile.birthday).format("MMMM DD, YYYY") : "",
        anniversary: profile.anniversary ? moment.utc(profile.anniversary).format("MMMM DD, YYYY") : "",

        checkedIn: checkedIn,
        proxyCheckedIn: false,

        familyReunion: eventInfo.hasFamilyReunion || "",
        firstFamilyReunion: eventInfo.firstFamilyReunion || "",
        familyReunionAttendance: eventInfo.attendanceAtLastFamilyReunion || "",

        uplineDiamond: businessInfo.uplineDiamond || "",
        yearDiamondQualified: businessInfo.yearDiamondQualified || "",

        gracePeriod: gracePeriod.isGracePeriod || "",
        gracePeriodStarted: gracePeriod.startedOn ? moment.utc(gracePeriod.startedOn).format("MMMM DD, YYYY") : "",

        yearQualifyingRequirements: qualify.year || 0,
        yearQualified: businessInfo.yearDiamondQualified || "",
        votingMemberYear: businessInfo.yearVotingMemberQualified || "",
        pinLevel: qualify.pinWearing || "-",
        garPoints: qualify.garPoints || 0,
        integratedGarPoints: qualify.integratedGarPoints || 0,
        diamondRankGar: qualify.diamondRankGar || 0,
        diamondRankWwg: qualify.diamondRankWWG || 0,
        capitalShare: qualify.capitalShare || 0,
        votingMember: qualify.isVotingMember || false,
        executiveCommittee: qualify.isExecutiveCommittee || false,
        yearExecutiveCommitteeQualified: businessInfo.yearExecutiveCommitteeQualified || "",
    };
}

const getAccessLevel = (userAccessLevel) => {
    const accessLevel = userAccessLevel || [];

    if (accessLevel.includes("EC"))
        return "EC";

    if (accessLevel.includes("MT1"))
        return "MT1";

    if (accessLevel.includes("MT2"))
        return "MT2";

    if (accessLevel.includes("GUEST"))
        return "GUEST";

    return "NONE";
}


